module.exports = function processArray(data = [], callback) {
    let index = 0;

    return new Promise(function(resolve, reject) {
        let next = function() {
            if (index < data.length) {
                callback(data[index++]).then(next, reject);
            } else {
                resolve();
            }
        };

        next();
    });
};
